import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Formik, Form, Field } from 'formik';
import { toast } from 'react-toastify';
import { InputAdornment as Icon } from '@material-ui/core';

import { createExercise } from '~/api';

import { Button } from '~/components/_layouts/forms/styles';
import Dialog from '~/components/Dialog';
import {
  SDialogTitle,
  ActionButtonSection,
  defaultFieldProps,
} from '../../components/Dialog/styles';
import Loading from '~/components/Loading';

const FORM_INITIAL_VALUES = {
  name: null,
  series: null,
  reps: null,
  weight: null,
  observations: 'Sem observações',
  video: null,
};

export default function NewExerciseDialog({
  isOpen,
  setIsOpen,
  blockId,
  orderedIndex,
  refreshBlocks,
}) {
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (values) => {
    setIsLoading(true);
    try {
      const block = { id: blockId };
      await createExercise({ ...values, block, orderedIndex });
      toast.success('Exercício criado com sucesso !');

      refreshBlocks();
    } catch (error) {
      toast.error('Ops, não foi possivel criar novo exercício!');
    } finally {
      setIsLoading(false);
      setIsOpen(false);
    }
  };

  return (
    <Dialog open={isOpen}>
      <SDialogTitle>Novo Exercício</SDialogTitle>
      <Formik initialValues={FORM_INITIAL_VALUES} onSubmit={handleSubmit}>
        <Form>
          <div>
            <Field
              name="name"
              label="Nome do exercício"
              required
              {...defaultFieldProps}
            />
            <Field
              name="series"
              type="number"
              label="Séries"
              {...defaultFieldProps}
            />
            <Field
              name="reps"
              type="number"
              label="Repetições"
              {...defaultFieldProps}
            />
            <Field
              name="weight"
              type="number"
              label="Carga"
              InputProps={{ endAdornment: <Icon position="end">Kg</Icon> }}
              {...defaultFieldProps}
            />
            <Field
              name="observations"
              label="Observações"
              {...defaultFieldProps}
            />
            <Field name="video" label="Link do video" {...defaultFieldProps} />
          </div>

          <ActionButtonSection>
            <Button
              disabled={isLoading}
              type="button"
              cancelButton
              onClick={() => setIsOpen(false)}
            >
              Cancelar
            </Button>
            <Button disabled={isLoading} type="submit">
              Criar
              {isLoading && <Loading buttonLoading />}
            </Button>
          </ActionButtonSection>
        </Form>
      </Formik>
    </Dialog>
  );
}

NewExerciseDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  setIsOpen: PropTypes.func.isRequired,
  blockId: PropTypes.number.isRequired,
  orderedIndex: PropTypes.number.isRequired,
  refreshBlocks: PropTypes.func.isRequired,
};
